<template>
    <div class="flex flex-col dark:text-white">
        <h1 class="text-xl font-semibold mb-4">Bloqueios de produtor</h1>

        <form @submit.prevent="applyFilters()" class="grid grid-cols-1 md:grid-cols-3 gap-3 mb-5">
            <div class="md:col-span-3">
                <litepie-datepicker
                    v-model="filters.date"
                    :formatter="{ date: 'DD/MM/YYYY', month: 'MMM' }"
                    :shortcuts="false"
                ></litepie-datepicker>
            </div>
            <input
                v-model="filters.email"
                placeholder="Email do aluno (inicio do endereco)"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            />
            <input
                v-model="filters.producer_id"
                placeholder="Producer ID"
                type="number"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            />
            <input
                v-model="filters.portal_id"
                placeholder="Portal ID"
                type="number"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            />
            <select
                v-model="filters.reason_code"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
                <option value="">Todos os motivos</option>
                <option value="misconduct">Conduta inadequada</option>
                <option value="payment_dispute">Disputa de pagamento</option>
                <option value="refund_request">Solicitou reembolso</option>
                <option value="terms_violation">Violou termos</option>
                <option value="producer_request">Solicitação do produtor</option>
                <option value="other">Outro</option>
                <option value="legacy">Backfill legacy</option>
            </select>
            <select
                v-model="filters.status"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
                <option value="">Todos os status</option>
                <option value="active">Ativo</option>
                <option value="expired">Expirado</option>
                <option value="deleted">Removido</option>
            </select>
            <div class="flex gap-2">
                <button
                    type="button"
                    @click.prevent="resetFilters()"
                    class="flex-1 inline-flex items-center justify-center px-4 py-2 text-sm rounded-md text-indigo-500 border-2 border-indigo-500 hover:text-white hover:bg-indigo-500"
                >
                    Limpar
                </button>
                <button
                    type="submit"
                    :disabled="loading"
                    :class="{'cursor-not-allowed': loading}"
                    class="flex-1 inline-flex items-center justify-center px-4 py-2 text-sm rounded-md text-white bg-indigo-500 hover:bg-indigo-400"
                >
                    Filtrar
                </button>
            </div>
        </form>

        <div v-if="history" class="mb-5 p-4 rounded-xl bg-white dark:bg-slate-800">
            <div class="flex items-center justify-between mb-2">
                <span class="font-semibold">Histórico de {{ history.email }}</span>
                <button @click.prevent="history = null" class="text-xs text-indigo-400 hover:underline">
                    Fechar
                </button>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                <div>Total: <span class="font-semibold">{{ history.stats.total }}</span></div>
                <div>Ativos: <span class="font-semibold">{{ history.stats.active }}</span></div>
                <div>Expirados: <span class="font-semibold">{{ history.stats.expired }}</span></div>
                <div>Removidos: <span class="font-semibold">{{ history.stats.removed }}</span></div>
            </div>
        </div>

        <div class="overflow-x-auto">
            <table class="border-collapse table-auto w-full text-sm bg-white dark:bg-slate-800 rounded-xl">
                <thead>
                <tr>
                    <th class="text-left px-4 py-3">Data</th>
                    <th class="text-left px-4 py-3">Produtor</th>
                    <th class="text-left px-4 py-3">Aluno</th>
                    <th class="text-left px-4 py-3">Portal</th>
                    <th class="text-left px-4 py-3">Motivo</th>
                    <th class="text-left px-4 py-3">Por (operator)</th>
                    <th class="text-left px-4 py-3">Status</th>
                    <th class="text-left px-4 py-3"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="ban in bans" :key="ban.id" class="border-b border-slate-100 dark:border-slate-700">
                    <td class="px-4 py-3">{{ formatDate(ban.created_at) }}</td>
                    <td class="px-4 py-3">{{ ban.producer_id }}</td>
                    <td class="px-4 py-3">
                        <a href="#" @click.prevent="showHistory(ban.email)" class="text-indigo-400 hover:underline">
                            {{ ban.email }}
                        </a>
                    </td>
                    <td class="px-4 py-3">{{ ban.portal_id }}</td>
                    <td class="px-4 py-3">
                        <span class="font-semibold">{{ reasonCodeLabel(ban.reason_code) }}</span>
                        <div class="text-xs text-slate-400">{{ ban.reason }}</div>
                    </td>
                    <td class="px-4 py-3">{{ ban.created_by || '-' }}</td>
                    <td class="px-4 py-3">
                        <span :class="statusClass(ban)">{{ statusLabel(ban) }}</span>
                    </td>
                    <td class="px-4 py-3">
                        <button @click="showHistory(ban.email)" class="text-xs text-indigo-400 hover:underline">
                            Histórico
                        </button>
                    </td>
                </tr>
                <tr v-if="!loading && bans.length === 0">
                    <td colspan="8" class="px-4 py-8 text-center text-slate-400">Nenhum ban encontrado.</td>
                </tr>
                </tbody>
            </table>

            <div v-if="pagination.total" class="flex w-full my-5">
                <div class="flex flex-col items-center mx-auto">
                    <span class="mb-1">
                        Exibindo {{ pagination.from }} a {{ pagination.to }} registros de {{ pagination.total }}
                    </span>
                    <pagination
                        :pagination="pagination"
                        :offset="1"
                        @paginate="fetch"
                    ></pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Pagination from '../../components/layouts/Pagination.vue';

// A listagem exige janela de data no backend. Sem ela a query varreria a
// tabela inteira, entao a tela ja abre com os ultimos 90 dias preenchidos.
const DEFAULT_WINDOW_IN_DAYS = 90;

function formatBrazilianDate(date) {
    const day = `${date.getDate()}`.padStart(2, '0');
    const month = `${date.getMonth() + 1}`.padStart(2, '0');

    return `${day}/${month}/${date.getFullYear()}`;
}

function defaultDateRange() {
    const to = new Date();
    const from = new Date();
    from.setDate(from.getDate() - DEFAULT_WINDOW_IN_DAYS);

    return [formatBrazilianDate(from), formatBrazilianDate(to)];
}

function defaultFilters() {
    return {
        email: '',
        producer_id: '',
        portal_id: '',
        reason_code: '',
        status: 'active',
        date: defaultDateRange(),
    };
}

export default {
    name: 'ProducerBans',
    components: { Pagination },
    data() {
        return {
            bans: [],
            loading: false,
            history: null,
            filters: defaultFilters(),
            pagination: {
                total: 0,
                per_page: 25,
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0,
            },
        };
    },
    mounted() {
        this.fetch();
    },
    methods: {
        async fetch() {
            this.loading = true;

            try {
                const { data } = await axios.get('/api/producer-bans', { params: this.buildParams() });

                this.bans = data.data || [];
                this.pagination = {
                    ...this.pagination,
                    total: data.total || 0,
                    per_page: data.per_page || this.pagination.per_page,
                    current_page: data.current_page || 1,
                    last_page: data.last_page || 1,
                    from: data.from || 0,
                    to: data.to || 0,
                };
            } catch (e) {
                console.error('Erro ao carregar producer bans', e);
            } finally {
                this.loading = false;
            }
        },
        buildParams() {
            const params = {
                per_page: this.pagination.per_page,
                page: this.pagination.current_page,
            };

            ['email', 'producer_id', 'portal_id', 'reason_code', 'status'].forEach((key) => {
                if (this.filters[key] !== '' && this.filters[key] !== null) {
                    params[`filter[${key}]`] = this.filters[key];
                }
            });

            const [from, to] = this.filters.date || [];

            if (from && to) {
                params['filter[from]'] = from;
                params['filter[to]'] = to;
            }

            return params;
        },
        applyFilters() {
            this.bans = [];
            this.pagination.current_page = 1;
            this.fetch();
        },
        async showHistory(email) {
            try {
                const { data } = await axios.get(`/api/producer-bans/history/${encodeURIComponent(email)}`);

                this.history = data;
            } catch (e) {
                console.error('Erro ao carregar histórico', e);
            }
        },
        resetFilters() {
            this.filters = defaultFilters();
            this.applyFilters();
        },
        formatDate(d) {
            return d || '-';
        },
        reasonCodeLabel(code) {
            const map = {
                misconduct: 'Conduta inadequada',
                payment_dispute: 'Disputa de pagamento',
                refund_request: 'Solicitou reembolso',
                terms_violation: 'Violou termos',
                producer_request: 'Pedido do produtor',
                other: 'Outro',
                legacy: 'Backfill legacy',
            };

            return map[code] || code || '-';
        },
        statusLabel(ban) {
            if (ban.deleted_at) return 'Removido';
            if (ban.expires_at && new Date(ban.expires_at) <= new Date()) return 'Expirado';
            return 'Ativo';
        },
        statusClass(ban) {
            if (ban.deleted_at) return 'text-slate-400';
            if (ban.expires_at && new Date(ban.expires_at) <= new Date()) return 'text-yellow-500';
            return 'text-red-500 font-semibold';
        },
    },
};
</script>
